import React,{useEffect, useState} from 'react';
import {Box} from '@mui/material';
import BtnPrimary from '../PrimaryButton';
import FormField from '../Formfield';
import Info from './Info';
import {getOrgDepartments, getOrgGroups} from '../../services/globalData'
import SortByTable from './SortByTable';

const SelectSortBy = ({loadNextPage, sortBy, setSortBy,selectedList, setSelectedList}) => {
  const [infoId,setInfoId]=useState("");
  const [isInfoDialogOpen,setIsInfoDialogOpen]=useState(false);
  const [data,setData] = useState();
  const allDepartments = getOrgDepartments();
  const allGroups = getOrgGroups(); 
  
  useEffect(()=>{
    setData(sortBy==="Departments"?allDepartments:allGroups);
  },[sortBy])

  const handleNextClick = () => { 
    loadNextPage("reviewSortBy")
  };

  return (
    <Box>
        <Box sx={{ maxWidth: "20rem", marginBottom: "1.5rem" }}>
            <Box sx={{ fontSize: "0.8125rem", fontWeight: 600, color: "#2A1D22", mb: "0.5rem" }}>Assign by</Box>
            <FormField
                type="select"
                options={["Departments","Groups"]}
                value={sortBy}
                onChange={(e)=>{setSortBy(e.target.value)}}
            />
         </Box>
         {sortBy && (
          <Box>
             <Box sx={{ fontWeight: 600, fontSize: "0.9375rem", color: "#2A1D22", marginBottom: "0.75rem" }}>
                    Select {sortBy.toLowerCase()}
              </Box>
              <SortByTable
                sortBy={sortBy}
                data={data}
                selectedList={selectedList}
                setSelectedList={setSelectedList}
              />
              <Box sx={{display:"flex", justifyContent:"end", gap: "1rem", marginTop: "2rem"}}>
                    <BtnPrimary
                      onClick={handleNextClick}
                      sx={{ height:"3rem", px: "2.5rem", borderRadius:"10px"}}
                    >
                       Next
                    </BtnPrimary>
              </Box>
          </Box>
         )}
         <Info open={isInfoDialogOpen} onClose={()=>setIsInfoDialogOpen(false)} infoId={infoId} sortBy={sortBy}/>
    </Box>
  )
}

export default SelectSortBy;